import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["status", "modal", "confirmButton"]

  submit(event) {
    if (event.submitter === this.confirmButtonTarget) return
    if (this.statusTarget.value !== "no_uploads") return

    event.preventDefault()
    Modal.getOrCreateInstance(this.modalTarget).show()
  }
}
